import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=60c8967e&scoped=true"
import script from "./CButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CButton.vue?vue&type=style&index=0&id=60c8967e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8967e",
  null
  
)

export default component.exports